import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-paper-plant",
  "use": "icon-paper-plant-usage",
  "viewBox": "0 0 17.73 15.1",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 17.73 15.1\" id=\"icon-paper-plant\"><defs><style>#icon-paper-plant .cls-1{opacity:0.97;}</style></defs><title>资源 115</title><g id=\"icon-paper-plant_图层_2\" data-name=\"图层 2\"><g id=\"icon-paper-plant_图层_1-2\" data-name=\"图层 1\"><path class=\"cls-1\" d=\"M17.69,1.34,15.36,14.17c-.17.91-.7,1.14-1.46.75L9.69,12,7.76,14a1.07,1.07,0,0,1-.82.43l.17-4.2,7.43-7.07c.33-.31-.08-.46-.52-.15L4.76,9.15.67,8c-.9-.26-.93-.86.14-1.32L16.51.09C17.25-.2,17.9.21,17.69,1.34Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/paper-plant.svg
// module id = 4FWg
// module chunks = 60